import React from "react";
import { IPoliticAdapterResponse } from "../../models/get-politic.model";

import download from "../../assets/images/download.png";
import fileTextNoRead from "../../assets/images/file_text_noread.png";
import fileTextRead from "../../assets/images/file_text_read.png";

interface ModalProps {
    politic: IPoliticAdapterResponse,
    onSelect: (politic: IPoliticAdapterResponse) => void;
    isDownload?: boolean;
}

export const PoliticCard = ({ politic, onSelect, isDownload = false } : ModalProps) => {
    return (
        <div className="politic-card">
            <div className="politic-card-body" onClick={() => politic.visited || !isDownload? onSelect(politic) : null}>
                <div className="check-section">
                    {
                        !isDownload && <input className="politic" type="checkbox" checked={politic.visited} readOnly />
                    }
                    {
                        isDownload && 
                        <div className="download-politic-image">
                            <img src={download} alt="download"></img>
                        </div>
                    }
                    <img src={politic.visited ? fileTextRead : fileTextNoRead } alt="isRead" />
                </div>
                <label>{politic.name}</label>
            </div>
        </div>
    )
}